import api from '@utils/api';

// Platform id → SSO audience for apps that accept a handoff ticket.
const SSO_AUD = { hr: 'hr', dashboard: 'planning', maintenance: 'cmms', training: 'training', logistics: 'logistics', safety: 'safety' };

/**
 * Open a platform target (top-level platform or sub-platform).
 *
 * externalApp targets are separate deployed apps (HR at /hr, CMMS at /cmms,
 * Planning on its own host) — real browser navigation, not React Router. For
 * apps that accept an SSO handoff, mint a short-lived single-use ticket first
 * and hand off to their /sso endpoint so the user isn't asked to log in again.
 * If ticketing fails, fall back to plain navigation (the target shows its own
 * login). Internal targets go through React Router.
 *
 * @param {{ platformId: string, externalApp?: string|null, path?: string }} target
 * @param {(path: string) => void} navigate - react-router navigate fn
 */
export async function openPlatformTarget({ platformId, externalApp, path }, navigate) {
  if (externalApp) {
    const aud = SSO_AUD[platformId];
    if (aud) {
      try {
        const { data } = await api.post('/auth/sso-ticket', { aud });
        window.location.href = `${externalApp}/sso?ticket=${encodeURIComponent(data.ticket)}`;
        return;
      } catch { /* fall through to plain navigation */ }
    }
    window.location.href = externalApp;
    return;
  }
  navigate(path);
}
